<odx-modal-header>
  <odx-area-header i18n="@@modal.selectCloudProject.header">Bitte Cloud-Projekt auswählen</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  @if (cloudProjects$ | async; as cloudProjects) {
    <app-import-cloud-projects-odx-table
      [cloudProjectMetadata]="cloudProjects"
      (projectSelected)="selectedProject = $event"
    ></app-import-cloud-projects-odx-table>
  } @else {
    <p [odxLoadingSpinner]="true" [odxLoadingSpinnerMinHeight]="500"></p>
  }
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="secondary" odxModalDismiss i18n="@@global.dismiss">Abbrechen</button>
  <button odxButton variant="primary" (click)="onConfirm()" i18n="@@modal.selectCloudProject.button.select">Auswählen</button>
</odx-modal-footer>
